import React from 'react';
import { Gift, CheckCircle2 } from 'lucide-react';
interface Bonus {
  num: string;
  title: string;
  intro: string;
  list?: string[];
  perks?: string[];
}
export function Bonuses() {
  const bonuses: Bonus[] = [{
    num: '01',
    title: 'SISTEMAS DE CIRCULACIÓN INTELIGENTE',
    intro: 'Aprendé cómo mejorar el movimiento del ganado con configuraciones pensadas para reducir frenadas, estrés y pérdida de tiempo.'
  }, {
    num: '02',
    title: 'GUÍA DE DISTRIBUCIÓN FUNCIONAL',
    intro: 'Configuraciones prácticas para organizar mejor:',
    list: ['apartaderos', 'accesos', 'zonas de trabajo', 'mangas', 'y circulación interna.'],
    perks: ['Distribución eficiente', 'Mejor aprovechamiento del espacio', 'Trabajo más cómodo y seguro']
  }, {
    num: '03',
    title: 'SISTEMAS MODERNOS DE MANEJO GANADERO',
    intro: 'Inspirate con configuraciones modernas utilizadas para optimizar:',
    list: ['manejo', 'clasificación', 'encierre', 'y trabajo diario.'],
    perks: ['Ideas modernas', 'Configuraciones premium', 'Manejo más eficiente']
  }, {
    num: '04',
    title: 'DISEÑOS ADAPTABLES PARA DIFERENTES PRODUCCIONES',
    intro: 'Modelos pensados para adaptarse a:',
    list: ['pequeños productores', 'establecimientos medianos', 'sistemas intensivos', 'y diferentes espacios rurales.'],
    perks: ['Diseños flexibles', 'Fácil adaptación', 'Aplicable a distintas necesidades ganaderas']
  }];
  return <section className="py-10 md:py-14 px-4 bg-black" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <div className="text-center mb-8 md:mb-10" data-id="element-18">
          <div className="inline-flex items-center gap-1.5 bg-brand-yellow text-brand-ink font-bold px-3.5 py-1 rounded-full mb-3 uppercase tracking-wider text-[11px] md:text-xs shadow-md border border-brand-yellow" data-id="element-19">
            <Gift className="w-3.5 h-3.5" data-id="element-20" /> Bonos exclusivos
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-white uppercase leading-tight" data-id="element-21">
            🎁 Bonos que se llevan{' '}
            <span className="highlight-green" data-id="element-22">GRATIS</span> con tu compra
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-zinc-900 rounded-xl border-2 border-brand-green/40 hover:border-brand-green transition-colors shadow-xl overflow-hidden flex flex-col" data-id="element-24">
              <div className="bg-gradient-to-r from-brand-green to-brand-greenDark text-white px-4 py-2.5 flex items-center gap-2.5" data-id="element-25">
                <div className="bg-white text-brand-green font-display font-black text-base w-8 h-8 rounded-md flex items-center justify-center shrink-0" data-id="element-26">
                  {bonus.num}
                </div>
                <p className="font-display font-bold tracking-wider uppercase text-xs md:text-sm" data-id="element-27">
                  🎁 BONUS {bonus.num}
                </p>
              </div>

              <div className="p-4 md:p-5 flex-grow flex flex-col" data-id="element-28">
                <h3 className="text-base md:text-lg font-display font-bold text-white uppercase leading-tight mb-2" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-xs md:text-sm text-zinc-300 mb-2.5 leading-relaxed" data-id="element-30">
                  {bonus.intro}
                </p>

                {bonus.list && <ul className="space-y-1 mb-3 pl-1.5" data-id="element-31">
                    {bonus.list.map((item, j) => <li key={j} className="text-xs md:text-sm text-zinc-300 flex items-start" data-id="element-32">
                        <span className="text-brand-greenLight font-bold mr-2" data-id="element-33">
                          •
                        </span>
                        <span data-id="element-34">{item}</span>
                      </li>)}
                  </ul>}

                {bonus.perks && <div className="mt-auto pt-3 border-t border-brand-green/30" data-id="element-35">
                    <ul className="space-y-1.5" data-id="element-36">
                      {bonus.perks.map((perk, j) => <li key={j} className="flex items-start gap-1.5" data-id="element-37">
                          <CheckCircle2 className="w-4 h-4 text-brand-greenLight shrink-0 mt-0.5" data-id="element-38" />
                          <span className="text-xs md:text-sm text-white font-semibold" data-id="element-39">
                            {perk}
                          </span>
                        </li>)}
                    </ul>
                  </div>}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}